import {
  GET_CUSTOMER_PAYMENTS_REQUESTED,
  GET_CUSTOMER_PAYMENTS_SUCCEEDED,
  GET_CUSTOMER_PAYMENTS_FAILED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = { byId: {}, byCustomerId: {}, isLoading: false }

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_CUSTOMER_PAYMENTS_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }

    case GET_CUSTOMER_PAYMENTS_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)
      const byCustomerId = DataMapper.objectIdsByAttribute(payload, "customerId")

      return {
        ...state,
        byId,
        byCustomerId,
        isLoading: false,
      }

    case GET_CUSTOMER_PAYMENTS_FAILED:
      return {
        ...state,
        isLoading: false,
      }

    case SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED:
      return {
        ...state,
        isLoading: true
      }

    case SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED:
      const customerPayment = payload?.data?.customerPayments[0] ?? {}

      return {
        ...state,
        byId: {
          ...state.byId,
          [customerPayment.uuid]: customerPayment
        },
        isLoading: false
      }

    case SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}
